export default __webpack_public_path__ + "static/media/Scotland-vs-Czech-Republic.c50689c3.jpeg";